import gql from 'graphql-tag'

import { TourFieldsFragment } from './tour'

export const CANCEL_TOUR_MUTATION = gql`
  mutation CancelTour($id: ID!, $cancelationReason: String!) {
    tour: cancelTour(id: $id, cancelationReason: $cancelationReason) {
      ...TourFields
    }
  }

  ${TourFieldsFragment}
`
